import './CreateProxyGroup.css'
import * as React                           from 'react'
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Button,
  Typography,
  Divider,
  TextField,
  Switch,
  Icon,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
}                                           from '@material-ui/core'
import {
  AccountModifier,
  createAddProxyGroupAccountModifier
}                                           from '../../../../../model/pacy/AccountModifiers'
import {
  Translate,
  TranslateFunction,
  withLocalize,
}                                           from 'react-localize-redux'
import Hint                                 from '../../../../../components/Hint/Hint'
import {
  ProxyGroupPossibleChannel
}                                           from "../../../../../model/pacy/ProxyGroup"

interface CreateProxyGroupOwnProps {
  closeModal          : () => void
  addAccountModifiers : (newActions:AccountModifier[]) => void
  accountId           : number
}
interface CreateProxyGroupProps extends CreateProxyGroupOwnProps {
  translate : TranslateFunction
}

const CreateProxyGroup = (props:CreateProxyGroupProps) => {
  const [name,setName] = React.useState('')
  const handleNameChange = (event) => {
    if(event.target.value.length <= 128) {
      setName(event.target.value)
    }
  }
  const [description,setDescription] = React.useState('')
  const handleDescriptionChange = (event) => {
    if(event.target.value.length <= 256) {setDescription(event.target.value)}
  }
  const [sharing,setSharing] = React.useState(false)
  const handleSetSharing = (event) => setSharing(event.target.checked)
  const handleSetSharingButton = () => setSharing(prevState=>prevState ? !prevState : true)
  const [channel, setChannel] = React.useState(ProxyGroupPossibleChannel.UNDEFINED)
  const handleChannelChange = (event: React.ChangeEvent<{ value: ProxyGroupPossibleChannel }>) => setChannel(event.target.value)
  const handleProxyGroupConfirm = () => {
    props.addAccountModifiers([createAddProxyGroupAccountModifier({accountId:props.accountId,channel:channel,name:name,description:description,sharing:sharing})])
  }
  return (
    <Card className="CreateProxyGroup">
      <CardHeader
        title={
          <Typography style={{display:'flex',alignItems:'center'}} variant="h6">
            <Icon style={{marginRight:5}}>add</Icon>
            <Translate id="pacyConfigs.createProxyGroup" />
          </Typography>
        }
      />
      <Divider />
      <CardContent className="Content">
        <div className="FirstRow">
          <div className="Name">
            <TextField fullWidth label={<Translate id="pacyConfigs.name"/>} variant="outlined" value={name} onChange={handleNameChange} />
          </div>
          <div className="Channel">
            <FormControl variant="outlined" fullWidth>
              <InputLabel shrink={channel !== ProxyGroupPossibleChannel.UNDEFINED} id="channel-label">{props.translate("pacyConfigs.channel")}</InputLabel>
              <Select
                labelId="channel-label"
                onChange={handleChannelChange}
                label={props.translate("pacyConfigs.channel")}
                value={channel === ProxyGroupPossibleChannel.UNDEFINED ? "" : channel}
              >
                {Object.values(ProxyGroupPossibleChannel).filter(channel=>channel != ProxyGroupPossibleChannel.UNDEFINED && channel != ProxyGroupPossibleChannel.MIXED).map(channel=>
                  <MenuItem key={channel} value={channel}>{props.translate("pacyConfigs.channels."+channel)}</MenuItem>
                )}
              </Select>
            </FormControl>
          </div>
          <div className="Sharing">
            <Button onClick={handleSetSharingButton} size="large" variant="outlined" color="primary">
              <Icon>call_split</Icon>
              <Translate id="pacyConfigs.sharing" />
              <Switch color="primary" size="medium" checked={sharing} onChange={handleSetSharing}/>
            </Button>
          </div>
        </div>
        <div className="Description">
          <TextField label={<Translate id="pacyConfigs.description"/>} variant="outlined" value={description} onChange={handleDescriptionChange} multiline rows={2} fullWidth />
        </div>
      </CardContent>
      <Divider />
      <CardActions className="CreateProxyGroupFooter">
        <Hint hint={props.translate('pacyConfigs.sharingHint') as string} />
        <div className="Buttons">
          <Button onClick={props.closeModal} color="secondary" variant="outlined" size="large" >
            <Translate id="common.cancel"/>
          </Button>
          <Button disabled={!name || channel === ProxyGroupPossibleChannel.UNDEFINED} onClick={()=>{handleProxyGroupConfirm();props.closeModal()}} style={{color:'white'}} color="primary" variant="contained" size="large" >
            <Translate id="pacyConfigs.done" />
          </Button>
        </div>
      </CardActions>
    </Card>
  )
}

export default withLocalize(CreateProxyGroup as any) as React.ComponentType<CreateProxyGroupOwnProps>
